
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Arborescence site web : Guide complet pour optimiser votre UX",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "L‘arborescence d’un site web est bien plus qu’une simple organisation de pages. C’est la colonne vertébrale de votre présence en ligne, le plan directeur qui guide vos visiteurs à travers leur voyage numérique.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Arborescence site web : Guide complet pour optimiser votre UX",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "L‘arborescence d’un site web est bien plus qu’une simple organisation de pages. C’est la colonne vertébrale de votre présence en ligne, le plan directeur qui guide vos visiteurs à travers leur voyage numérique.",
        },
      ],
    };
  },
};
